/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../../../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { PrintLabelPageService } from "../../../../../services";

const MODULE_NAME = "printLabel.machines.states.getLabelPDF";
const log: any = LoggerModule?.getInstance();

const getSrv = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.PrintLabelPageService") as PrintLabelPageService;
};

export const getLabelPDF = async (context: any, event: any) => {
  const currentState = "GET_LABEL_PDF";
  const method = "getLabelPDF";

  return new Promise(async (resolve, reject) => {
    try {
      log.blue(MODULE_NAME, "context: ", context, "event: ", event);

      const srv = getSrv();
      const content = await srv.getLabelPDF(event?.payload);

      if (content) {
        return resolve({
          key: "GET_LABEL_PDF_SUCCESS",
          value: {
            ...(content || {}),
          },
        });
      } else {
        const msg = "Label Generation failed";
        log.error(MODULE_NAME, `error in ${method}, msg: ${msg}`);
        return reject({
          key: "GET_LABEL_PDF_FAILED",
          value: msg,
        });
      }
    } catch (err: any) {
      log.error(MODULE_NAME, `error in ${method}, msg: ${err?.message}`);
      return reject({
        key: "GET_LABEL_PDF_FAILED",
        value: err?.message,
      });
    }
  });
};
